export enum InvoiceStatusEnum {
  PENDING = "PENDING",
  READY_FOR_BILLING = "READY_FOR_BILLING",
  INVOICED = "INVOICED",
  COLLECTED = "COLLECTED",
}

export function getInvoiceStatusLabel(status: InvoiceStatusEnum): string {
  switch (status) {
    case InvoiceStatusEnum.PENDING:
      return "Pendiente";
    case InvoiceStatusEnum.READY_FOR_BILLING:
      return "Pasado a facturar";
    case InvoiceStatusEnum.INVOICED:
      return "Facturado";
    case InvoiceStatusEnum.COLLECTED:
      return "Cobrado";
  }
}

export function getInvoiceStatusActionLabel(status: InvoiceStatusEnum): string {
  switch (status) {
    case InvoiceStatusEnum.READY_FOR_BILLING:
      return "Pasar a facturar";
    default:
      return "";
  }
}

export const getInvoiceStatusOptions = (): { label: string; value: string }[] =>
  Object.keys(InvoiceStatusEnum).map((val) => {
    const value = InvoiceStatusEnum[val as keyof typeof InvoiceStatusEnum];
    return { label: getInvoiceStatusLabel(value), value: value, translate: true };
  });

export function canMarkInvoiceAsReadyForBilling(status: InvoiceStatusEnum): boolean {
  return status === InvoiceStatusEnum.PENDING;
}

export function canEditInvoiceFromCertification(status: InvoiceStatusEnum): boolean {
  return status === InvoiceStatusEnum.PENDING;
}
